/* TPL Featured Stories — IG-style tap-to-advance video stories */
(function () {
  'use strict';

  var frames = document.querySelectorAll('[data-stories-frame]');
  if (!frames.length) return;

  frames.forEach(function (frame) {
    var slides    = Array.prototype.slice.call(frame.querySelectorAll('.tpl-stories__slide'));
    var bars      = Array.prototype.slice.call(frame.querySelectorAll('[data-bar]'));
    var counterEl = frame.querySelector('[data-stories-counter]');
    var muteBtn   = frame.querySelector('[data-stories-mute]');
    var prevBtn   = frame.querySelector('[data-stories-prev]');
    var nextBtn   = frame.querySelector('[data-stories-next]');
    var total     = slides.length;
    if (total === 0) return;

    var section = frame.closest('.tpl-stories');
    var DURATION_MS = (function () {
      var raw = section
        ? getComputedStyle(section).getPropertyValue('--tpl-story-duration').trim()
        : '8s';
      var n = parseFloat(raw);
      return (raw.slice(-2) === 'ms') ? n : n * 1000;
    })();

    var idx           = 0;
    var muted         = true;
    var inView        = false;
    var paused        = false;
    var advTimer      = null;
    var advStart      = 0;
    var advRemaining  = DURATION_MS;
    var holdTimer     = null;
    var transitioning = false;
    var TRANSITION_MS     = 380;
    var HOLD_THRESHOLD_MS = 180;

    function pad(n) { return n < 10 ? '0' + n : '' + n; }

    function updateCounter() {
      if (counterEl) counterEl.textContent = pad(idx + 1) + ' / ' + pad(total);
    }

    function updateNavLabels() {
      if (prevBtn) prevBtn.setAttribute('aria-label', 'Story ' + (idx === 0 ? total : idx) + ' of ' + total + ', previous');
      if (nextBtn) nextBtn.setAttribute('aria-label', 'Story ' + (idx === total - 1 ? 1 : idx + 2) + ' of ' + total + ', next');
    }

    function getVideo(slide) { return slide.querySelector('[data-story-video]'); }

    /* ── Video ── */
    function playVideo(slide) {
      var v = getVideo(slide);
      if (!v) return;
      v.muted = muted;
      v.currentTime = 0;
      var p = v.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
    }

    function pauseVideo(slide) {
      var v = getVideo(slide);
      if (v && !v.paused) v.pause();
    }

    function resumeVideo(slide) {
      var v = getVideo(slide);
      if (!v || !v.paused) return;
      var p = v.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
    }

    function muteAll(shouldMute) {
      slides.forEach(function (s) {
        var v = getVideo(s);
        if (v) v.muted = shouldMute;
      });
    }

    /* ── Progress bars — batch DOM reads to avoid layout thrash ── */
    function resetBars(activeIdx) {
      /* Single pass: set all classes, then one forced reflow for the active bar only */
      bars.forEach(function (b, i) {
        b.classList.remove('is-active', 'is-done', 'is-paused');
      });
      /* Single reflow to flush animation state on the target bar */
      if (bars[activeIdx]) void bars[activeIdx].offsetWidth;
    }

    function updateBarsForIdx(targetIdx) {
      resetBars(targetIdx);
      bars.forEach(function (b, i) {
        if (i < targetIdx) {
          b.classList.add('is-done');
        }
      });
      if (bars[targetIdx] && inView && !paused) {
        bars[targetIdx].classList.add('is-active');
      }
    }

    function pauseBar(i) { var b = bars[i]; if (b) b.classList.add('is-paused'); }
    function resumeBar(i) { var b = bars[i]; if (b) b.classList.remove('is-paused'); }

    /* ── Timer ── */
    function startTimer(duration) {
      clearTimeout(advTimer);
      advStart     = Date.now();
      advRemaining = duration;
      advTimer = setTimeout(function () { goTo(idx + 1, 'next'); }, duration);
    }

    function pauseTimer() {
      if (!advTimer) return;
      clearTimeout(advTimer);
      advTimer = null;
      advRemaining = Math.max(0, advRemaining - (Date.now() - advStart));
    }

    function resumeTimer() {
      if (advTimer) return;
      if (advRemaining <= 50) advRemaining = DURATION_MS;
      startTimer(advRemaining);
    }

    function clearTimer() {
      clearTimeout(advTimer);
      advTimer = null;
    }

    /* ── Slide transition ── */
    function goTo(targetIdx, direction) {
      if (targetIdx >= total) targetIdx = 0;
      if (targetIdx < 0) targetIdx = total - 1;
      if (targetIdx === idx || transitioning) return;

      transitioning = true;
      clearTimer();

      var current = slides[idx];
      var target  = slides[targetIdx];

      /* Update bars for new index */
      updateBarsForIdx(targetIdx);

      /* Position target off-screen without transition */
      target.style.transition = 'none';
      target.style.transform  = direction === 'next' ? 'translateX(100%)' : 'translateX(-100%)';
      void target.offsetWidth;

      /* Animate both slides */
      var ease = 'cubic-bezier(0.16, 1, 0.3, 1)';
      var dur  = TRANSITION_MS + 'ms';
      target.style.transition  = 'transform ' + dur + ' ' + ease;
      current.style.transition = 'transform ' + dur + ' ' + ease;
      target.style.transform   = 'translateX(0)';
      current.style.transform  = direction === 'next' ? 'translateX(-25%)' : 'translateX(25%)';

      /* Aria updates */
      current.setAttribute('aria-hidden', 'true');
      target.removeAttribute('aria-hidden');
      target.classList.add('is-active');

      /* After transition: sequence pause-then-play to avoid iOS single-play restriction */
      setTimeout(function () {
        try {
          current.classList.remove('is-active');
          current.style.transition = 'none';
          current.style.transform  = 'translateX(100%)';
          void current.offsetWidth;
          current.style.transition = '';

          /* Pause outgoing BEFORE playing incoming (iOS allows only one autoplay at a time) */
          pauseVideo(current);
          if (inView && !paused) playVideo(target);

          idx = targetIdx;
          updateCounter();
          updateNavLabels();
          if (inView && !paused) startTimer(DURATION_MS);
        } finally {
          transitioning = false;
        }
      }, TRANSITION_MS);
    }

    /* ── Pause / resume ── */
    function pauseAll() {
      if (paused) return;
      paused = true;
      pauseTimer();
      pauseBar(idx);
      pauseVideo(slides[idx]);
    }

    function resumeAll() {
      if (!paused) return;
      paused = false;
      if (!inView) return;
      resumeTimer();
      resumeBar(idx);
      resumeVideo(slides[idx]);
    }

    /* ── Mute ── */
    if (muteBtn) {
      muteBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        muted = !muted;
        muteAll(muted);
        muteBtn.classList.toggle('is-unmuted', !muted);
        muteBtn.setAttribute('aria-label', muted ? 'Unmute video' : 'Mute video');
      });
    }

    /* ── Tap navigation ── */
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        if (paused) return;
        goTo(idx - 1, 'prev');
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        if (paused) return;
        goTo(idx + 1, 'next');
      });
    }

    /* ── Hold to pause — CRITICAL: exclude tap zone buttons ── */
    frame.addEventListener('pointerdown', function (e) {
      if (e.target.closest('[data-stories-mute],[data-stories-prev],[data-stories-next]')) return;
      clearTimeout(holdTimer);
      holdTimer = setTimeout(pauseAll, HOLD_THRESHOLD_MS);
    });

    function onHoldEnd() {
      clearTimeout(holdTimer);
      if (paused) resumeAll();
    }

    frame.addEventListener('pointerup',     onHoldEnd);
    frame.addEventListener('pointercancel', onHoldEnd);
    frame.addEventListener('pointerleave',  function (e) {
      if (!frame.contains(e.relatedTarget)) {
        clearTimeout(holdTimer);
        if (paused) resumeAll();
      }
    });

    /* ── Keyboard ── */
    frame.setAttribute('tabindex', '0');
    frame.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); goTo(idx + 1, 'next'); }
      if (e.key === 'ArrowLeft'  || e.key === 'ArrowUp')   { e.preventDefault(); goTo(idx - 1, 'prev'); }
    });

    /* ── IntersectionObserver ── */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !inView) {
            inView = true;
            /* Only activate if not user-paused */
            if (!paused) {
              updateBarsForIdx(idx);
              playVideo(slides[idx]);
              startTimer(DURATION_MS);
            }
          } else if (!entry.isIntersecting && inView) {
            inView = false;
            clearTimer();
            pauseBar(idx);
            pauseVideo(slides[idx]);
          }
        });
      }, { threshold: 0.35 });
      io.observe(frame);
    } else {
      inView = true;
      updateBarsForIdx(idx);
      playVideo(slides[idx]);
      startTimer(DURATION_MS);
    }

    /* ── Init: position all non-active slides off-screen right ── */
    slides.forEach(function (s, i) {
      if (i !== 0) s.style.transform = 'translateX(100%)';
    });
    updateCounter();
    updateNavLabels();
  });
})();
